import { clearProfileInfoData, setProfileInfoData, validateProfileInfoData } from './profile_info';
import { clearOtherInfoData, setOtherInfoData, validateOtherInfoData } from './other_info';
import { clearKycInfoData, setKycInfoData, validateKycInfoData } from '../kyc';
import { clearProfileAddressData, setProfileAddressData, validateAddressInfoData } from '../profile_address';
import { clearGloablMessage, setLoading, setGlobalMessage } from '../app';
import { ALERT_SEVERITY, ERROR_MESSAGES, VALIDATION_MESSAGES } from 'eebac/constants';
import ApiDataHelper from 'eebac/utils/apiDataHelper';
import CompanyInfoFields from 'eebac/constants/fields/compnay/company_profile_info';
import AddressInfoFields from 'eebac/constants/fields/address';
import KycInfoFields from 'eebac/constants/fields/kyc';
import { Catch } from '../api_exception';
import { setAvatar } from './avatar';
import { setUserBoxProfile } from '../userbox_profile';
import { ROUTES_PATH_CONFIG } from 'eebac/config/routes';
import { clearSecurityInfoData, setSecurityInfoData, validateSecurityInfoData } from '../security_info';

const BASE_PATH = "COMPANY_PROFILE";

const setProfileData = (dispatch, profileData) => {
    dispatch(setAvatar(profileData.avatar));
    dispatch(setUserBoxProfile(profileData.avatar,
        profileData.userName, profileData.score, ROUTES_PATH_CONFIG.COMPANY.profile,
        profileData.companyInfoData.code))

    ApiDataHelper.set(
        (data) => dispatch(setProfileInfoData(data)),
        profileData.companyInfoData,
        { ...CompanyInfoFields, address: {} });

    ApiDataHelper.set(
        (data) => dispatch(setProfileAddressData(data)),
        profileData.addressInfoData,
        AddressInfoFields);

    ApiDataHelper.set(
        (data) => dispatch(setKycInfoData(data)),
        profileData.kycInfoData,
        KycInfoFields);

    ApiDataHelper.set(
        (data) => dispatch(setOtherInfoData(data)),
        profileData.otherInfoData,
        { companyTypes: "", companyPresence: "", additionalInfo: "" });

    dispatch(setSecurityInfoData([{ key: "password", value: "" }]));
}

export const updateProfile = () =>
    (dispatch, getState, client) => {

        let state = getState();
        let profileAvatar = state.COMPANY_AVATAR_DATA.avatar;
        if (!profileAvatar) {
            dispatch(setGlobalMessage(VALIDATION_MESSAGES.PROFILE_PHOTO, ALERT_SEVERITY.ERROR));
            return;
        }

        dispatch(setLoading(true));
        let apiData = {
            avatar: profileAvatar,
            companyInfoData: ApiDataHelper.get(state.COMPANY_PROFILE_INFO,
                CompanyInfoFields),
            addressInfoData: ApiDataHelper.get(state.PROFILE_ADDRESS,
                AddressInfoFields),
            kycInfoData: ApiDataHelper.get(state.COMPANY_KYC_DATA,
                KycInfoFields),
            otherInfoData: {
                companyTypes: state.COMPANY_OTHER_INFO.companyTypes,
                companyPresence: state.COMPANY_OTHER_INFO.companyPresence,
                additionalInfo: state.COMPANY_OTHER_INFO.additionalInfo,
            },
            securityInfoData: {
                password: state.SECURITY_INFO.password
            }
        }

        client.put('/company/profile', apiData)
            .then(res => res.data).then(result => {
                dispatch(setLoading(false));
                if (result.isSuccess &&
                    result.data.profile) {
                    dispatch(setGlobalMessage(result.successMessage));
                    setProfileData(dispatch, result.data.profile);

                } else {
                    if (result.data.companyInfoDataErrors &&
                        Array.isArray(result.data.companyInfoDataErrors)) {
                        dispatch(setProfileInfoData(result.data.companyInfoDataErrors))
                    }

                    if (result.data.addressInfoData &&
                        Array.isArray(result.data.addressInfoData)) {
                        dispatch(setProfileAddressData(result.data.addressInfoData))
                    }

                    if (result.data.kycInfoDataErrors &&
                        Array.isArray(result.data.kycInfoDataErrors)) {
                        dispatch(setKycInfoData(result.data.kycInfoDataErrors))
                    }

                    if (result.data.otherInfoDataErrors &&
                        Array.isArray(result.data.otherInfoDataErrors)) {
                        dispatch(setOtherInfoData(result.data.otherInfoDataErrors))
                    }

                    if (result.data.securityInfoDataErrors &&
                        Array.isArray(result.data.securityInfoDataErrors)) {
                        dispatch(setSecurityInfoData(result.data.securityInfoDataErrors))
                    }

                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                }
            }).catch(error => {
                Catch(error, dispatch);
            });
    }

export const validateProfile = () =>
    (dispatch, getState, client) => {

        let state = getState();
        dispatch(validateProfileInfoData())
        dispatch(validateAddressInfoData());
        dispatch(validateKycInfoData());
        dispatch(validateOtherInfoData());
        dispatch(validateSecurityInfoData());
    }


export const loadProfile = () =>
    (dispatch, getState, client) => {
        dispatch(setLoading(true));

        dispatch(clearProfileInfoData());
        dispatch(clearProfileAddressData());
        dispatch(clearKycInfoData());
        dispatch(clearOtherInfoData());
        dispatch(clearSecurityInfoData());
        dispatch(setAvatar(""));

        client.get('/company/profile').
            then(res => res.data).then(result => {
                dispatch(setLoading(false));
                if (result.isSuccess &&
                    result.data.profile) {
                    setProfileData(dispatch, result.data.profile);
                } else {
                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                }
            }).catch(error => {
                Catch(error, dispatch);
            });
    }


export const PROFILE_FORM_SUBMIT = `${BASE_PATH}/PROFILE_FORM_SUBMIT`;

export const setProfileFormSubmit = (isSubmit) => ({
    type: PROFILE_FORM_SUBMIT,
    isSubmit
});

const initialState = {
    isSubmit: ""
}

export function ProfileFormSubmitReducer(state = { ...initialState }, action) {
    switch (action.type) {
        case PROFILE_FORM_SUBMIT:
            return { ...state, isSubmit: action.isSubmit };
    }

    return state;
}